import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { Breadcrumb } from 'react-breadcrumbs'
import { Grid, Row, Col } from 'react-bootstrap'
import { PageTitle } from 'Components/PageTitle'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { AmbassadorWrapper } from 'Components/City/Page/Ambassador/AmbassadorWrapper'
import { AmbassadorSection } from 'Components/City/Page/Ambassador/AmbassadorSection'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import PinUserIcon from 'Assets/Images/icons/pinUser'
import { PATHS } from 'Config/Routing/paths'
import { getAmbassadorByIdGraphQL } from 'Reducers/Ambassador/actions'
import AmbassadorUploadDocumentsWrapper from './UploadDocumentsForm'

const BreadcrumbsAmbassadorUploadDocuments = ({ currentPath }) => {
  return (
    <div>
      <Breadcrumbs icon={<PinUserIcon style={{ width: 16 }} />} />
      <Breadcrumb
        data={{ title: 'Dashboard', pathname: `${PATHS.main.dashboard}` }}
      />
      <Breadcrumb
        data={{
          title: 'Cities',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
        }}
      />
      <Breadcrumb
        data={{
          title: 'Brand Ambassadors',
          pathname: currentPath.replace('/upload-documents', ''),
        }}
      />
      <Breadcrumb data={{ title: 'Documents', pathname: currentPath }} />
    </div>
  )
}

const AmbassadorUploadDocuments = ({ countryCode }) => {
  const match = useRouteMatch()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAmbassadorByIdGraphQL(match.params.ambassadorId))
  }, [])

  const ambassador = useSelector(state => state.ambassadors.ambassadorById)
  return (
    <HideWhenBlocked>
      <AmbassadorWrapper>
        <BreadcrumbsAmbassadorUploadDocuments currentPath={match.url} />
        <PageTitle>
          {ambassador.firstName} {ambassador.lastName}
          {ambassador.status && (
            <span className="status">({ambassador.status})</span>
          )}
        </PageTitle>

        <AmbassadorSection>
          <Grid fluid>
            <Row>
              <Col xs={12}>
                <SectionTitle>Upload ambassador documents</SectionTitle>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                {ambassador.id && (
                  <AmbassadorUploadDocumentsWrapper
                    ambassadorId={ambassador.id}
                    countryCode={countryCode}
                  />
                )}
              </Col>
            </Row>
          </Grid>
        </AmbassadorSection>
      </AmbassadorWrapper>
    </HideWhenBlocked>
  )
}

export default AmbassadorUploadDocuments



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/UploadDocuments/index.js